import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCoreConfigDistributionBoard = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M23.4198 45.801V54.2051L10 46.765V13.8833L23.4198 21.3235V24.3326",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.4194 26.3079V43.6381",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.3797 33.5511L13.6143 29.8017C13.2602 29.6047 13.0435 29.2319 13.0435 28.8271V28.3052L19.8088 32.0545C20.163 32.2516 20.3797 32.6244 20.3797 33.0291V33.5511Z",
			strokeWidth: .5,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.3797 30.7442L13.6143 26.9948C13.2602 26.7978 13.0435 26.425 13.0435 26.0203V25.4983L19.8088 29.2477C20.163 29.4447 20.3797 29.8175 20.3797 30.2223V30.7442Z",
			strokeWidth: .5,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.3797 27.9422L13.6143 24.1928C13.2602 23.9958 13.0435 23.623 13.0435 23.2182V22.6963L19.8088 26.4457C20.163 26.6427 20.3797 27.0155 20.3797 27.4202V27.9422Z",
			strokeWidth: .5,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.4194 45.7846V54.2047L50.0001 41.3536V8.47192L23.4194 21.3231V24.263",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.4194 26.542V43.787",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.4324 50.6574L47.9855 39.7555V12.0186L25.4324 22.9205V50.6574Z",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0303 13.8512L36.6109 1L49.999 8.47212L23.4184 21.3233L10.0303 13.8512Z",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.0113 29.8178C40.043 29.8818 40.043 29.9563 40.0113 30.0468L37.7069 36.0863C37.6751 36.1715 37.6117 36.2461 37.543 36.2887L37.4849 36.31C37.4056 36.326 37.3527 36.2727 37.3527 36.1822L37.3421 32.6778L35.9838 33.466C35.9151 33.5033 35.8569 33.5033 35.82 33.4553C35.7882 33.4074 35.7882 33.3222 35.82 33.237L38.1191 27.1975C38.1508 27.1123 38.2142 27.0325 38.2883 26.9899C38.3041 26.9792 38.3146 26.9739 38.3305 26.9685C38.4151 26.9473 38.468 27.0005 38.468 27.0963L38.4785 30.6007L39.8422 29.8072C39.9109 29.7646 39.9743 29.7699 40.006 29.8178H40.0113Z",
			strokeWidth: .5,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.2871 30.8558L21.5217 29.8759V25.4128L23.2871 26.3928V30.8558Z",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.2874 30.8564L25.0368 30.0096V25.5466L23.2874 26.3934V30.8564Z",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5261 25.4074L23.2756 24.5659L25.0356 25.5459L23.2862 26.3927L21.5261 25.4074Z",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.2871 50.2101L21.5217 49.2355V44.7725L23.2871 45.7524V50.2101Z",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.2874 50.2095L25.0368 49.368V44.905L23.2874 45.7519V50.2095Z",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5261 44.7673L23.2756 43.9258L25.0356 44.9057L23.2862 45.7526L21.5261 44.7673Z",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.6938 52.5433L36.7329 51.4569V47.83L38.6938 46.8713V52.5433Z",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.6938 52.5425L40.6389 51.6052V45.9438L38.6938 46.9025V52.5425Z",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.6938 52.5433L36.7329 51.4569V47.83L38.6938 46.8713V52.5433Z",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.6938 52.5425L40.6389 51.6052V45.9438L38.6938 46.9025V52.5425Z",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.6938 52.5433L36.7329 51.4569V47.83L38.6938 46.8713V52.5433Z",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.6938 52.5425L40.6389 51.6052V45.9438L38.6938 46.9025V52.5425Z",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.6938 52.5433L36.7329 51.4569V47.83L38.6938 46.8713V52.5433Z",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.6938 52.5425L40.6389 51.6052V45.9438L38.6938 46.9025V52.5425Z",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.6331 55.4293L30.6721 54.3428V50.7159L32.6331 49.7573V55.4293Z",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.6313 55.43L34.5764 54.4927V48.8313L32.6313 49.7899V55.43Z",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.3671 58.38L24.4062 57.2935V53.6666L26.3671 52.708V58.38Z",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.3682 58.3803L28.3132 57.4429V51.7869L26.3682 52.7402V58.3803Z",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgCoreConfigDistributionBoard;
